module.exports = __webpack_public_path__ + "media/images/missing-cde13a37.png";